module.exports = __webpack_public_path__ + "rvcnn_price_tag_jewellry_design_handmade_craft_paper_logo.jpg?b8cb6b68b20383a9b3ea8f9350fb1a65";


//////////////////
// WEBPACK FOOTER
// ./src/assets/portfolio/rvcnn/rvcnn_price_tag_jewellry_design_handmade_craft_paper_logo.jpg
// module id = 104
// module chunks = 0